/* eslint-disable react/prop-types */

import React, { useEffect, useState } from 'react';
import { find } from 'lodash';
import { Row, Col } from 'reactstrap';
import { Field, useSession } from '@cordata/buffet';
import formatPostCode from '@cordata/buffet/build/helpers/formatPostCode';

import { authorizedInstance as axios } from '~/utils';

const LocationForm = ({
  setFieldValue,
  status,
  setStatus,
  values,
  index,
}) => {
  const [states, setStates] = useState([]);
  const [types, setTypes] = useState([]);
  const { debugMode } = useSession();

  useEffect(() => {
    axios
      .get('reference-country-divisions')
      .then(r => r.data.data)
      .then((r) => {
        setStates(r);
      });

    axios
      .get('reference-data/reference-address-type')
      .then(r => r.data.data)
      .then((r) => {
        setTypes(r);
      });
  }, []);

  useEffect(() => {
    if (
      states.length &&
      values.addresses[index].state &&
      values.addresses[index].state.length === 2
    ) {
      setFieldValue(`addresses.${index}.state`, find(states, s => (values.addresses[index].state === s.attributes.divisionAbbrevIso)));
    }

    if (
      types.length &&
      values.addresses[index].addressTypeUid
    ) {
      setFieldValue(`addresses.${index}.addressType`, find(types, s => values.addresses[index].addressTypeUid === s.id));
    }
  }, [types, states, values.addresses[index]]);

  const onPostCodeChange = (e) => {
    const postCode = e.target.value;

    setFieldValue(`addresses.${index}.postCode`, postCode);

    if (postCode.length >= 5) {
      setStatus({
        [`address-${index}`]: {
          county: {
            loading: true,
          },
          city: {
            loading: true,
          },
          state: {
            loading: true,
          },
        },
      });

      axios
        .get(`reference-data/reference-geo-data?zip_code=${postCode}`)
        .then(r => r.data.data)
        .then(r => r[0])
        .then((r) => {
          setFieldValue(`addresses.${index}.county`, r ? r.attributes.county : undefined);
          setFieldValue(`addresses.${index}.city`, r ? r.attributes.city : undefined);
          setFieldValue(`addresses.${index}.state`, find(states, s => r && s.attributes.divisionAbbrevIso === r.attributes.state));

          setStatus({
            [`address-${index}`]: {
              county: {
                loading: false,
              },
              city: {
                loading: false,
              },
              state: {
                loading: false,
              },
            },
          });
        });
    }
  };

  return (
    <>
      {debugMode && (
        <Field
          name={`addresses.${index}.id`}
          label="ID"
          disabled
        />
      )}

      <Row form>
        <Col sm>
          <Field
            name={`addresses.${index}.address1`}
            label="Address 1"
            placeholder="Enter Address 1"
            loading={status && status[`address-${index}`] && status[`address-${index}`].address ? status[`address-${index}`].address.loading : undefined}
          />
        </Col>

        <Col sm>
          <Field
            name={`addresses.${index}.address2`}
            label="Address 2"
            loading={status && status[`address-${index}`] && status[`address-${index}`].address ? status[`address-${index}`].address.loading : undefined}
          />
        </Col>

        <Col sm>
          <Field
            name={`addresses.${index}.isPrimary`}
            label="Primary Address"
            type="checkbox"
          />
        </Col>

        <Col sm>
          <Field
            name={`addresses.${index}.addressType`}
            label="Type"
            placeholder="Type"
            type="select"
            options={types}
            getOptionValue={o => o.attributes.addressTypeName}
            getOptionLabel={o => o.attributes.addressTypeLabel}
          />
        </Col>
      </Row>

      <Row form>
        <Col sm>
          <Field
            name={`addresses.${index}.city`}
            label="City"
            placeholder="Enter City"
            loading={status && status[`address-${index}`] && status[`address-${index}`].city ? status[`address-${index}`].city.loading : undefined}
          />
        </Col>

        <Col sm>
          <Field
            name={`addresses.${index}.state`}
            label="State"
            placeholder="Enter State"
            options={states}
            type="select"
            loading={status && status[`address-${index}`] && status[`address-${index}`].state ? status[`address-${index}`].state.loading : undefined}
            getOptionValue={o => o.attributes.divisionAbbrevIso}
            getOptionLabel={o => o.attributes.divisionLabel}
          />
        </Col>

        <Col sm>
          <Field
            name={`addresses.${index}.postCode`}
            label="Post Code"
            placeholder="Enter Post Code"
            format={formatPostCode}
            loading={status && status[`address-${index}`] && status[`address-${index}`].postCode ? status[`address-${index}`].postCode.loading : undefined}
            onChange={onPostCodeChange}
          />
        </Col>

        <Col sm>
          <Field
            name={`addresses.${index}.county`}
            label="County"
            placeholder="Enter County"
            loading={status && status[`address-${index}`] && status[`address-${index}`].county ? status[`address-${index}`].county.loading : undefined}
          />
        </Col>
      </Row>

      {debugMode && (
        <Row form>
          <Col sm>
            <Field
              name={`addresses.${index}.latitude`}
              label="Latitude"
              disabled
            />
          </Col>

          <Col sm>
            <Field
              name={`addresses.${index}.longitude`}
              label="Longitude"
              disabled
            />
          </Col>
        </Row>
      )}
    </>
  );
};

export default LocationForm;
